<script>
    import { onMount } from 'svelte';
    import GitHubIcon from '../img/github.svg';
    import LinkedInIcon from '../img/linkedin.svg';
    
  // 소셜 미디어 링크
  const socialLinks = [
    { name: 'GitHub', url: 'https://github.com/kyungminpark0127', icon: GitHubIcon },
    { name: 'LinkedIn', url: 'https://www.linkedin.com/in/hyeji-park-340032341', icon: LinkedInIcon },
  ];
    
    // 연락처 정보
    const contactInfo = {
      email: 'kyungminpark0127@protonmail.com',
      location: 'Seoul, South Korea'
    };
</script>

<div class="contact-container">
	<h1>Contact Me</h1>
	
	<div class="contact-content">
		<div class="contact-card">
			<h2>Let's Connect</h2>
			<p>Feel free to reach out with any questions, opportunities, or just to say hello!</p>
			
			<div class="info-items">
				<div class="info-item">
					<span class="info-label">Email:</span>
					<a href="mailto:{contactInfo.email}">{contactInfo.email}</a>
				</div>
				<div class="info-item">
					<span class="info-label">Location:</span>
					<span>{contactInfo.location}</span>
				</div>
			</div>
		</div>
		
		<div class="social-card">
			<h2>Follow Me</h2>
			<div class="social-icons">
				{#each socialLinks as link}
					<a href={link.url} target="_blank" rel="noopener noreferrer" class="social-icon">
						<img src={link.icon} alt={link.name} />
						<span>{link.name}</span>
					</a>
				{/each}
			</div>
		</div>
	</div>
</div>

<style>
	.contact-container {
		max-width: 1200px;
		margin: 80px auto 0;
		padding: 0 20px;
	}

	h1 {
		font-size: var(--font-size-title, 2rem);
		margin-bottom: 1.5rem;
		color: var(--color-text, #000000);
	}
	
	.contact-content {
		display: flex;
		flex-direction: column;
		gap: 3rem;
		margin-top: 2rem;
		max-width: 600px;
	}
	
	.contact-card, .social-card {
		background-color: none;
		border-radius: 8px;
		padding: 2rem;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
	}
	
	h2 {
		font-size: 1.5rem;
		margin: 0 0 1rem 0;
		border-bottom: 1px solid #eee;
		padding-bottom: 0.5rem;
	}
	
	.info-items {
		margin: 1.5rem 0;
	}
	
	.info-item {
		margin-bottom: 1rem;
	}
	
	.info-label {
		font-weight: bold;
		margin-right: 0.5rem;
	}
	
	.info-item a {
		color: #007BFF;
		text-decoration: none;
	}
	
	.info-item a:hover {
		text-decoration: underline;
	}
	
	.social-icons {
		display: flex;
		flex-wrap: wrap;
		gap: 1.5rem;
		margin-top: 1rem;
	}
	
	.social-icon {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		text-decoration: none;
		color: inherit;
		transition: transform 0.2s;
	}
	
	.social-icon:hover {
		transform: translateY(-2px);
	}
	
	.social-icon img {
		width: 24px;
		height: 24px;
	}
	
	/* 반응형 디자인 */
	@media (max-width: 768px) {
		.contact-content {
			padding: 0 1rem;
		}
	}
</style>